import "../App.css";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useThemeColor from "../hooks/TopBarColorWheel";
import useContainerHeight from "../hooks/useContainerHeight";

const POLL_INTERVAL_MS = 3000;
const API_BASE = "https://www.fyl.la:4000/api/";
// const API_BASE = "http://192.168.0.231:4000/api/";

const SUCCESS_STATES = new Set(["AUTHORIZED", "CAPTURED"]);
const FAILED_STATES = new Set(["ABORTED", "EXPIRED", "TERMINATED", "FAILED"]);

export function PaymentPendingPage() {
  useThemeColor();
  const containerHeight = useContainerHeight();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const reference = searchParams.get("reference");
  const cancelledRef = useRef(false);

  useEffect(() => {
    if (!reference) {
      navigate("/payment-error", { replace: true });
      return;
    }

    cancelledRef.current = false;

    const poll = async () => {
      try {
        const res = await fetch(
          `${API_BASE}payment-status/${encodeURIComponent(reference)}`,
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const { state } = await res.json();

        if (cancelledRef.current) return;

        if (SUCCESS_STATES.has(state)) {
          navigate("/betaling", { replace: true });
          return;
        }
        if (FAILED_STATES.has(state)) {
          navigate("/payment-aborted", { replace: true });
          return;
        }
        // still CREATED or unknown-transient — keep polling
      } catch (err) {
        console.error("Payment status poll failed:", err);
      }
    };

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);
    return () => {
      cancelledRef.current = true;
      clearInterval(id);
    };
  }, [reference, navigate]);

  return (
    <div className="App" style={{ height: containerHeight - 48 }}>
      <div
        className="App-header"
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <p className="text-h1">VENTER PÅ BETALING</p>
        <p className="text-h1 top-margin-m">IKKE LUKK DENNE FANEN</p>
      </div>

      <div className="background"></div>
    </div>
  );
}
